










import {Component, Prop, Vue} from "vue-property-decorator";
import BookItem from "@/components/navbar/BookItem.vue";

@Component({
  components: {BookItem},
})
export default class Navbar extends Vue {
  @Prop({type: Boolean, default: false}) readonly hide!: boolean;

  goToLanding(): void {
    this.$router.push({name: "Landing"});
  }
}
